export default __webpack_public_path__ + "images/0x912ce59144191c1204e64559fe8253a0e49e6548.png";